import * as Yup from "yup";

export const manualPaymentSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .min(2, "Name should be at least 2 characters"),

  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),

  mobile: Yup.string()
    .required("Mobile is required")
    .matches(/^\d{10}$/, "Mobile must be exactly 10 digits"),

  paymentId: Yup.string()
    .required("Payment ID is required")
    .min(3, "Payment ID should be at least 3 characters"),
  paymentStatus: Yup.string()
    .required("Payment Status is required")
    .oneOf(["Completed", "Pending", "Failed"], "Invalid payment status"),

  webinarName: Yup.string().max(100, "Webinar name is too long"),
  dummyPayment: Yup.string().required("Select payment type"),
});
